// @flow
import styled from 'styled-components';
import colors from '../../../assets/css/colors';

export const Label = styled.label`
	display: block;
	color: ${({ is_error }) => is_error ? colors.red : colors.nrlDarkGreen};
	font-size: 12px;
	font-weight: bold;
	margin: 1em 0;
	opacity: ${({ is_disabled }) => is_disabled ? '.5' : '1'};
`;

export default Label;


// WEBPACK FOOTER //
// ./src/components/Form/Label/index.js